import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';

const GET_CHANGE_PROPOSAL = graphql(`
  query GetChangeProposal($id: ID!) {
    changeProposal(id: $id) {
      id
      paymentSchedule {
        stages {
          stage {
            ...PaymentScheduleStageFields
          }
          stageValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoice {
            id
            reference
            customReference
            isDepositInvoice
            totalValue {
              value
            }
          }
          invoiceValue {
            value
            currency {
              id
              code
              exponent
            }
          }
          invoiceProjectPercentage
        }
        explainer
        isInSync
      }
      effectivePaymentSchedule {
        stages {
          ...DerivedPaymentStageFields
        }
        explainer
      }
    }
  }
`);

const useGetChangeProposal = (changeProposalId?: string) => {
  return useQuery({
    enabled: !!changeProposalId,
    queryKey: proposalKeys.changeProposal(changeProposalId!),
    queryFn: () => {
      return gqlClient.request(GET_CHANGE_PROPOSAL, {
        id: changeProposalId!,
      });
    },
  });
};

export default useGetChangeProposal;
